// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader__loader___1yjj8","ball-talk":"Loader__ball-talk___1BBL2","ball-decide":"Loader__ball-decide___2Wb7J","ball-listen":"Loader__ball-listen___3fwbj","ball-help":"Loader__ball-help___PBGWO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Loader.scss
// module id = JshY
// module chunks = 0